import { DASHBOARD_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';

export interface GetBrandSalesStateGroupRulesResponse {
  brand_id: number;
  rules_text: string;
}

export interface UpsertBrandSalesStateGroupRulesParams {
  rules_text: string;
}

interface Interface {
  get: (brandId: number) => Promise<GetBrandSalesStateGroupRulesResponse>;
  upsert: (
    brandId: number,
    params: UpsertBrandSalesStateGroupRulesParams
  ) => Promise<void>;
  delete: (brandId: number) => Promise<void>;
}

export class BrandSalesStateGroupRulesService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async get(
    brandId: number
  ): Promise<GetBrandSalesStateGroupRulesResponse> {
    return await this.restClient.get<GetBrandSalesStateGroupRulesResponse>(
      `${DASHBOARD_API_ORIGIN}/api/brands/${brandId}/sales-state-group-rules` as const
    );
  }

  public async upsert(
    brandId: number,
    params: UpsertBrandSalesStateGroupRulesParams
  ): Promise<void> {
    return await this.restClient.put(
      `${DASHBOARD_API_ORIGIN}/api/brands/${brandId}/sales-state-group-rules` as const,
      params
    );
  }

  public async delete(brandId: number): Promise<void> {
    return await this.restClient.delete(
      `${DASHBOARD_API_ORIGIN}/api/brands/${brandId}/sales-state-group-rules` as const
    );
  }
}
